import { pick } from "ramda";

import { EventQuery } from "lib/build/events";
import { Interpretation, LogItem, Tag } from "lib/build/schema";

export function mapLogItemsToEventQueries(items: LogItem[]): EventQuery[] {
	const queries: EventQuery[] = [];
	for (const { details } of items) {
		if ("interpretations" in details) {
			for (const interpretation of details.interpretations as Interpretation[]) {
				const query: EventQuery = {
					interpretation: stripInterpretation(interpretation)
				};
				if ("tags" in details) {
					query.tags = [];
					for (const tag of details.tags as Tag[]) {
						query.tags.push(stripTag(tag));
					}
				}
				queries.push(query);
			}
		}
	}
	return queries;
}

function stripInterpretation(i: Interpretation): Interpretation {
	return pick(["vocab", "code"], i);
}

function stripTag(t: Tag): Tag {
	return pick(["vocab", "code", "source"], t);
}
